var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('profile-overview',{attrs:{"viewing_user_id":_vm.viewing_user_id,"viewing_type":"member_dashboard"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }